import React, { useEffect, useState, useRef } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import EnhancedTable from "@meetyoo/components/src/components/Table/EnhancedTable";
import Box from "@mui/material/Box";
import TableLayout from "../TableLayout";
import InfoModal from "../Modal/InfoModal";
import { useDefaultPasscodeStyles } from "../../../../constants/passCodeUtils";
import { initialSearchFilter, defaultTableLayout } from "../../../../reducers/projectmail";
import { ClosedFilter } from "../Filter";

import { getSearchedTickets, setTableLayout } from "../../../../actions/projectmail";
import TableConfigurator from "../TableLayout/TableConfigurator";
import TableSelector from "../TableSelector";
import EmailModal from "../Modal/EmailModal/EmailModal";

const type = "closed";

export const ClosedTicketsTableComponent = ({
  stateTickets,
  getTicketsFn,
  filter,
  title,
  pageing,
  translate,
  tableLayout,
  setInitialTableLayoutFn,
}) => {
  const pc = useDefaultPasscodeStyles();
  const [ownTickets, setOwnTickets] = useState(stateTickets[type] ? [...stateTickets[type]] : undefined);
  const [openFilter, setOpenFilter] = useState(filter ? filter.changed : false);
  const [page, setPage] = useState(0);
  const [rows, setRows] = useState(25);
  const filterRef = useRef();
  const [openSettings, setOpenSettings] = useState(false);
  const [inProgress, setInProgress] = useState(false);
  useEffect(() => {
    if (tableLayout === undefined) {
      setInitialTableLayoutFn(type);
    }
  }, [setInitialTableLayoutFn, tableLayout]);

  const createHeadRow = () => {
    return tableLayout.map(tItem => ({
      id: tItem,
      label: translate[TableConfigurator[tItem].label],
    }));
  };
  // request for tickets
  useEffect(() => {
    const request = async () => {
      if (stateTickets === undefined) await getTicketsFn(filter || initialSearchFilter, type);
      else {
        if (stateTickets[type] === undefined) {
          await getTicketsFn(filter || initialSearchFilter);
        }
        if (ownTickets !== stateTickets[type]) {
          setOwnTickets(stateTickets[type]);
        }
      }
    };
    request();
  }, [ownTickets, getTicketsFn, stateTickets, setOwnTickets, filter]);

  // request for avaiable tags

  const checkNextPage = async returnedPage => {
    if (pageing && (returnedPage * rows) % 100 === 0) {
      setInProgress(true);
      await getTicketsFn(filter || initialSearchFilter, (returnedPage * rows) / 100 - 1);
      setInProgress(false);
    }
    setPage(returnedPage);
  };

  return ownTickets && ownTickets.length > -1 && tableLayout !== undefined ? (
    [
      <div key="table">
        <EnhancedTable
          title={title}
          rows={ownTickets}
          inProgress={inProgress}
          headRows={createHeadRow()}
          tableRowComponent={TableLayout}
          rowProps={{
            setOpenFilter: boolean => {
              setOpenFilter(boolean);
            },
            setFilter: (filterValue, filterKey) => filterRef.current.setFilter(filterValue, filterKey),
            type,
          }}
          deleteButton={false}
          selectAll={false}
          rowsPerPageState={25}
          openFilter={openFilter}
          filterChildren={
            <ClosedFilter
              ref={filterRef}
              resetFn={() => {
                // setTicketsFn(stateTickets.defaultTickets[type], type);
              }}
              closeFilter={() => setOpenFilter(false)}
              openFilter={openFilter}
              inProgress={inProgress}
              setInProgress={bool => {
                setInProgress(bool);
                setPage(0);
              }}
            />
          }
          callBackExpand={event => {
            setOpenFilter(event);
          }}
          sizeOfRows={rows.length}
          setReturnRowsPerPage={size => setRows(size)}
          pageState={page}
          setReturnPage={returnedPage => checkNextPage(returnedPage)}
          stateSortBy="lastContactAt"
          oderState="desc"
          settingsCallback={() => setOpenSettings(!openSettings)}
        />
      </div>,
      <InfoModal key="modal" />,
      <EmailModal key="tableModal" />,
      <TableSelector type={type} open={openSettings} onClose={() => setOpenSettings(false)} key="settings" />,
    ]
  ) : (
    <div>
      <Box
        sx={[
          pc.lineBreak,
          {
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            fontSize: "24px",
            fontWeight: "bold",
          },
        ]}
      >
        ...LOADING {title}
      </Box>
    </div>
  );
};

ClosedTicketsTableComponent.defaultProps = {
  stateTickets: undefined,
  filter: undefined,
  pageing: false,
  tableLayout: undefined,
};

ClosedTicketsTableComponent.propTypes = {
  stateTickets: PropTypes.object,
  title: PropTypes.string.isRequired,
  getTicketsFn: PropTypes.func.isRequired,
  filter: PropTypes.object,
  pageing: PropTypes.bool,
  tableLayout: PropTypes.array,
  translate: PropTypes.object.isRequired,
  setInitialTableLayoutFn: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  stateTickets: state.projectmail.tickets,
  filter: state.projectmail.searchFilter[type],
  tags: state.projectmail.tags,
  colorMap: state.projectmail.colorMap,
  translate: state.ui.translate,
  tableLayout: state.projectmail.tableLayout[type],
});

const mapDispatchToProps = dispatch => ({
  getTicketsFn: async (filter, page) => {
    await dispatch(getSearchedTickets(filter, type, page));
  },
  setInitialTableLayoutFn: () => dispatch(setTableLayout(defaultTableLayout, type)),
});

const ClosedTicketsTable = connect(
  mapStateToProps,
  mapDispatchToProps
)(ClosedTicketsTableComponent);

export default ClosedTicketsTable;
